import { forwardRef } from 'react';

interface ViewerIconButtonProps {
  /** Accessible name, e.g. "Close image viewer". */
  label: string;
  /** SVG path data of a 24x24 stroke icon. */
  path: string;
  onClick: () => void;
  /** Positioning classes, e.g. "absolute right-4 top-4". */
  className?: string;
}

/** Icon button used by the full-screen image and video viewers. */
export const ViewerIconButton = forwardRef<HTMLButtonElement, ViewerIconButtonProps>(
  ({ label, path, onClick, className = '' }, ref) => (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      onClick={onClick}
      className={`flex h-11 w-11 items-center justify-center rounded-lg bg-white/10 text-white transition-colors hover:bg-white/25 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white ${className}`}
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        className="h-6 w-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d={path} />
      </svg>
    </button>
  )
);

ViewerIconButton.displayName = 'ViewerIconButton';
